import globalStyles from "../../../../../assets/styles/base/globalPage.module.scss";
import primaryComponents from "../../../../primaryComponents";
import secondaryComponents from "../../..";
import { formatCurrency } from "../../../../../helpers";
import { useCardListener } from "../CardListener/useCardListener";
import { CheckMarkCircle, TimesCircle } from "../../../../../assets/svgIcons";
import styles from "../CardListener/styles.module.scss";

export const DynamicTransferListener = ({
  amount = 0,
  paymentProvider,
  closeModal = () => {},
}) => {
  const {
    isLoading,
    paymentStatus,
    countDown,
    isCreatingOrder,
    hitThirdParty,
    isCheckingStatus,
    isCanceling,
    sessionDetails,
    terminalDetails,
    triggerSessionCreation,
    cancelTransaction,
    setHitThirdParty,
    proceedToNext,
  } = useCardListener({
    amount,
    paymentProvider,
    paymentMethod: "transfer",
    closeModal,
  });

  return (
    <div>
      <div className={styles.routedModal__header}>
        <h4 className="mb-0">Accept Transfer Payments</h4>

        <primaryComponents.Button
          classNames={"btn btn--outline-red"}
          isDisabled={paymentStatus === "PAID" || isCanceling}
          isLoading={isCanceling}
          loadingText={"Canceling..."}
          onClick={() => {
            if (!sessionDetails) return closeModal();

            cancelTransaction();
          }}
        >
          Cancel Payment
        </primaryComponents.Button>
      </div>

      <div className="text-center">
        <div className="my-4">
          <p>Amount</p>
          <h3>{formatCurrency({ value: amount })}</h3>
        </div>

        <secondaryComponents.LoaderHelper
          isLoading={isLoading}
          classNames={"mt-4"}
        >
          <div
            className={`${globalStyles.cardWithBorder} align-items-center justify-content-center`}
            style={{ minHeight: "150px" }}
          >
            {terminalDetails?.account_number && (
              <div
                className={`${globalStyles.cardWithBackground} py-4 mb-4 w-100`}
              >
                <h4 className="gray--text font-weight-normal mb-0">
                  Account Number:{" "}
                  <span className="purple--text">
                    {terminalDetails?.account_number}
                  </span>
                </h4>
                <p>
                  Account Name:{" "}
                  <span className="dark--text">
                    {terminalDetails?.account_name}
                  </span>
                </p>
                <p>
                  Bank Name:{" "}
                  <span className="dark--text">
                    {terminalDetails?.bank_name}
                  </span>
                </p>
              </div>
            )}

            {paymentStatus === "PENDING" || paymentStatus === "PROCESSING" ? (
              <div>
                <h6 className="small-text-size">
                  Payment session has been sent to the terminal assigned to this
                  device and store
                </h6>
                <p className="mt-3">
                  Kindly ask the customer to transfer the exact amount displayed
                  on your POS screen
                </p>

                <secondaryComponents.LoaderHelper
                  classNames={"mt-4"}
                  isLoading={true}
                ></secondaryComponents.LoaderHelper>
                <p className="smallest-text-size">Listening for transfer</p>
              </div>
            ) : paymentStatus === "PAID" ? (
              <div>
                <CheckMarkCircle
                  className="success--text"
                  style={{ fontSize: "50px" }}
                />
                <h5 className="success--text">Transfer Payment Successful</h5>
                <p>
                  Confirming payment in{" "}
                  <span className="purple--text">{countDown}</span>
                </p>
              </div>
            ) : (
              <div>
                <TimesCircle
                  className="error--text"
                  style={{ fontSize: "50px" }}
                />
                <h5 className="error--text">Transfer Payment Failed</h5>
              </div>
            )}
          </div>

          <div className={`${globalStyles.bottomButtonCover} mt-5`}>
            <primaryComponents.Button
              className="btn btn--outline cover"
              isDisabled={paymentStatus !== "FAILED" || isLoading}
              isLoading={isLoading}
              loadingText={"Resending..."}
              onClick={() => triggerSessionCreation()}
            >
              Resend Payment to POS
            </primaryComponents.Button>
            {paymentStatus === "PAID" ? (
              <primaryComponents.Button
                className="btn btn--success cover"
                isDisabled={isCreatingOrder}
                isLoading={isCreatingOrder}
                loadingText={"Processing..."}
                onClick={() => proceedToNext()}
              >
                Create Order
              </primaryComponents.Button>
            ) : (
              <primaryComponents.Button
                className="btn btn--primary cover"
                isDisabled={isCheckingStatus && hitThirdParty}
                isLoading={isCheckingStatus && hitThirdParty}
                loadingText={"Confirming..."}
                onClick={() => setHitThirdParty(true)}
              >
                Payment Has Been Made
              </primaryComponents.Button>
            )}
          </div>
        </secondaryComponents.LoaderHelper>
      </div>
    </div>
  );
};
